import Top from './pages/Top.vue';
import Intro from './pages/Intro.vue';

export default [
    {
        path: '/',
        component: Top
    },
    {
        path: '/intro',
        component: Intro
    }
];


// WEBPACK FOOTER //
// ./src/routes.js